/*
 * Copyright (c) 2025 CalAmp Corp.  All Rights Reserved
 */
import {convertSvgToDataUri} from '@ion/core/src/utils/Encoding';
import {dlsColor} from '@ion/dls/src/theme/theme';

export interface AssetEventNoGPSMarker {
  size?: number,
  fillColor?: string
};

/**
 * Defines the default Asset Event Marker for No GPS which is used to render the background svg.
 *
 * ```typescript
 *
 *   return new Graphic({
 *     geometry   : {type: 'point', latitude, longitude},
 *     symbol     : {
 *       type : 'picture-marker',
 *       url  : getAssetEventNoGPSMarker(),
 *       width,
 *       height
 *     }
 *   });
 *
 * ```
 *
 */
export const getAssetEventNoGPSMarker = ({
  fillColor = dlsColor('grey4'),
  size = 24
}: AssetEventNoGPSMarker) => {
  const svg = (`
    <svg width='${size}' height='${size}' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path fill-rule='evenodd' clip-rule='evenodd' d='M12 1.2C6.03528 1.2 1.19995 6.03532 1.19995 12C1.19995 17.9647 6.03528 22.8 12 22.8C17.9646 22.8 22.8 17.9647 22.8 12C22.7933 6.03806 17.9619 1.20661 12 1.2Z' fill='${fillColor}'/>
      <path fill-rule='evenodd' clip-rule='evenodd' d='M12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C20.9944 16.9683 16.9683 20.9944 12 21V21Z' fill='white'/>
      <path d='M12 18L12 10' stroke='${fillColor}' stroke-width='2' stroke-miterlimit='10'/>
      <path d='M12 8V6' stroke='${fillColor}' stroke-width='2' stroke-miterlimit='10'/>
    </svg>
  `);
  return convertSvgToDataUri(svg.trim());
};

export default getAssetEventNoGPSMarker;
